import { couponRegex } from "../../utils/string";
import { getCoupon } from "../../reducers/methods";
import get from "lodash/get";

export const redirect = ({
  url,
  type,
  couponObject,
  originalUrl,
}: {
  type?: "newTab" | "sameTab";
  url: string;
  couponObject?: ReturnType<typeof getCoupon>;
  originalUrl?: string;
}) => {
  const testableUrl = originalUrl ? originalUrl : url;
  const containsCoupon = couponRegex.test(testableUrl);
  const waitingForCoupon =
    containsCoupon && get(couponObject, "status") === "pending";

  if (waitingForCoupon) {
    return;
  }

  if (type === "sameTab") {
    (window.top.location as any) = url;
  } else {
    const newTab = window.open(url, "_blank");

    if (newTab) {
      newTab.focus();
    }
  }
};
